module.exports = __webpack_public_path__ + "img/124.ee44cb2a.png";